import { defineComponent } from '@vue/composition-api';
import MyBox from '../sub-components/box.vue';
export default defineComponent({
  components: {
    MyBox: MyBox
  },
  props: {
    giftList: {
      type: Array,
      required: true
    }
  },
  setup: function setup(props, ctx) {
    return {};
  }
});